export default "__VITE_ASSET__BnnAMHUx__"